import { TextField } from '@mui/material'

import withStyles from '@mui/styles/withStyles'
import makeStyles from '@mui/styles/makeStyles'

export const StyledTextField = withStyles(theme => ({
  root: {
    width: '100%',
    padding: '0',
    margin: 'auto',

    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: `${theme.palette.primary.main} !important`
      }
    }
  }
}))(TextField)

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    width: ({ width }) => width && `${width}px`,
    alignItems: 'center',

    '& div[class*="MuiOutlinedInput-root"]': {
      padding: '0px !important'
    },

    '& fieldset[class*="MuiOutlinedInput-notchedOutline"]': {
      borderWidth: '1px !important'
    },

    '& [class*="MuiOutlinedInput-root"]:hover [class*="MuiOutlinedInput-notchedOutline"]':
      {
        borderColor: '#C6C6C6'
      },

    '& .Mui-focused fieldset': {
      borderColor: `${theme.palette.primary.main} !important`
    },

    '& input': {
      paddingLeft: '32px !important',
      fontSize: theme.size.sm,
      height: ({ height }) => (height ? height : 18),

      '&::placeholder': {
        color: ({ customPlaceholder }) =>
          customPlaceholder && '#888888 !important',
        opacity: ({ customPlaceholder }) => customPlaceholder && '1 !important'
      }
    }
  },

  textField: {
    width: '100%'
  },

  box: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #C6C6C6',
    boxSizing: 'border-box',
    borderRadius: '4px',
    padding: '4px 8px',
    background: '#F5F6F8',
    fontSize: theme.size.sm,
    color: '#8F8F8F'
  },

  addTagBox: {
    cursor: 'pointer'
  },

  icon: {
    marginRight: '8px'
  },

  muiIcon: {
    height: 14,
    width: 14
  },

  inputIcon: {
    position: 'absolute',
    left: '10px'
  },

  menuItem: {
    fontSize: theme.size.base,
    fontFamily: '"Inter", sans-serif',

    '& svg': {
      marginRight: 7,
      height: 12,
      width: 12
    }
  }
}))

export default useStyles
